import { html, nothing, unsafeCSS, type CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LibElement } from '../lib-element';
import { CheckedFormElement } from '../checked-form-element';
import css from './lib-switch.css';

/** A settings switch with a clickable label. */
@customElement('lib-switch')
export class LibSwitch extends CheckedFormElement {
  protected override get revisionEventName(): string { return 'lib-switch-change'; }
  protected override get hostFocusSelector(): string { return 'button'; }
  static override readonly styles: CSSResultGroup = [LibElement.hostStyles, unsafeCSS(css.replaceAll('__TICK_ICON__', new URL('../wago-icons-svg/tick-sign.svg', import.meta.url).href))];

  /** String submitted when on; the boolean value API is unchanged. */
  @property({ attribute: 'submit-value' }) submitValue = 'on';
  @property({ type: Boolean, reflect: true }) error = false;

  get value(): boolean { return this.checked; }
  protected override get submissionValue(): string { return this.submitValue; }

  override render() {
    return html`<div class="switch-div" role="group">
      <label id="label" @click=${this.#toggle}><slot></slot></label>
      <button type="button" role="switch" aria-labelledby="label" aria-checked=${String(this.checked)}
        aria-invalid=${this.error ? 'true' : nothing}
        class="switch ${this.checked ? 'on' : 'off'} ${this.error ? 'switch-error' : ''}"
        ?disabled=${this.effectivelyDisabled} @click=${this.#toggle}>
        <span class="icon-check ${this.checked ? 'on' : 'off'}"></span>
      </button>
    </div>`;
  }

  #toggle(event: MouseEvent): void {
    if (this.effectivelyDisabled) {
      event.stopPropagation();
      return;
    }
    this.revision++;
    this.checked = !this.checked;
    this.syncFormValue();
    this.notifyChange();
  }
}

declare global {
  interface HTMLElementTagNameMap { 'lib-switch': LibSwitch; }
}
